// extracted by mini-css-extract-plugin
export default {"rating-inputs-box":"NumberRating_rating-inputs-box__tKuRG","rating-inputs":"NumberRating_rating-inputs__rsbYN"};